module.exports = __webpack_public_path__ + "static/img/5-open.68d968b7.png";